import React, { useEffect, useState } from 'react';
import { DashboardProvider } from '../../../dashboard/context';
import { useSetFilterCollapseMutation } from '../../../../features/authentication/assignApiSlice';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import { DataProvider } from '../../DataContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown,faChevronUp, faFileMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { useLocation } from 'react-router';
import { NavLink } from 'react-router-dom';
import ActivitiesSearchFilter from '../../../activities/ActivitiesSearchFilter';
import ActivitiesList from '../../../activities/ActivitiesList';
import { useIsActivitiesExistMutation } from '../../../../features/authentication/activityApiSlice';
import { useActivityContext } from '../../../activities/context';
import EmptyActivitiesState from '../../../activities/components/EmptyActivitiesState';
import ActivityCreateContent from '../../../activities/components/ActivityCreateContent';

const Activities = () => {
  const { isActivitiesAvailable, setIsActivitiesAvailable, noOfActivities, isFiltersCollapsed, setIsFiltersCollapsed, filtersInitialized } = useActivityContext();
  const [checkActivitiesAvailable] = useIsActivitiesExistMutation();
  const [setFilterCollapse] = useSetFilterCollapseMutation();
  const location = useLocation();
  const [key, setKey] = useState(location?.state?.keyProp ?? 'search');

  useEffect(() => {
    isActivityExist();
  }, []);

  const isActivityExist = async () => {
    const response = await checkActivitiesAvailable().unwrap();
    setIsActivitiesAvailable(response);
  };

  const setCollapseState = async (isCollapsed) => {
    const options ={
      isCollapsed:isCollapsed
    };
    await setFilterCollapse(options).unwrap();
  };

  const [activityBtnState] = useState({
    btns: [
      {
        id: 'search-activities',
        name: 'Search Flashcards',
        key: 'search'
      },
      {
        id: 'create-activities',
        name: 'Create New Flashcard',
        key: 'create'
      },
      {
        id: 'browse-activities',
        name: 'Browse Vocabularies',
        key: 'browse',
        comingSoon: false
      }
    ]
  });

  return (
    <DashboardProvider>
      <>
        <DataProvider>
          {isActivitiesAvailable && (
            <>
              <div className='tabbed-content'>
                <Tabs
                  activeKey={key}
                  onSelect={(k) => setKey(k)}>
                  {activityBtnState.btns.map((item, index) => {
                    if (item.comingSoon) return null;
                    return (                
                      <Tab
                        eventKey={item.key}
                        key={item.id + index}
                        id={item.id}
                        title={<div className={'tab-title'} >
                          {item.name}</div>}>
                        {item.id == 'search-activities' && <div className={`p-4 ${isFiltersCollapsed ? 'd-none':''}`}
                          id="search-content">
                          <ActivitiesSearchFilter />
                        </div>}
                        {item.id == 'create-activities' && <div className={`p-4 ${isFiltersCollapsed ? 'd-none':''}`}
                          id="create-content">
                          <ActivityCreateContent showBrowseContent={false} showTitle={true} fromActivities={true}/>
                        </div>}
                        {item.id == 'browse-activities' && <div className={`p-4 ${isFiltersCollapsed ? 'd-none':''}`}
                          id="browse-content">
                          <NavLink
                            to={'/activitiesSearch'}
                            className="select-questions border-0 h-100 p-4 d-flex flex-column align-items-center justify-content-center text-center text-decoration-none">
                            <span className="mb-3 d-flex align-items-center justify-content-center nav-link-browse-content">
                              <FontAwesomeIcon color="#82A9E2" icon={faFileMagnifyingGlass} />
                            </span>
                            <h4>Browse Vocabularies</h4>
                            <p className="mb-0">Select the vocabularies first, then create a new flashcard.</p>
                          </NavLink>
                        </div>}
                      </Tab>                  
                    );
                  })}</Tabs>
              </div>
              <div className='align-collapsible-btn'>
                <button
                  onClick={() => {setCollapseState(!isFiltersCollapsed); setIsFiltersCollapsed(!isFiltersCollapsed);}}
                  className="rounded-circle z-index10 collapsible-btn">
                  <FontAwesomeIcon icon={isFiltersCollapsed ? faChevronDown : faChevronUp} />
                </button>
              </div>
            </>
          )}
          <div className='d-flex mb-4'>
            <div>
              <h3 className="primary-title mb-lg-0">
            Current Flashcards{' '}
                {isActivitiesAvailable && (
                  <small className="opacity-50">({noOfActivities})</small>
                )}
              </h3>
            </div>
          </div>
          <EmptyActivitiesState />
          {isActivitiesAvailable && filtersInitialized && (
            <ActivitiesList/>
          )}
        </DataProvider>
      </>
    </DashboardProvider>
  );
};

export default Activities;
